import { getApi } from "../apiCall";

// Contract metadata (LOA, supplier/receiver, banking factor, return period, trader).
// discom_id is the logged-in discomId; state_id defaults to 6.
const BASE_URL = `${process.env.REACT_APP_API_URL}/banking/insights/banking_otc`;

const buildQuery = (params) => {
  const query = Object.entries(params)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== "",
    )
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  return query ? `?${query}` : "";
};

// GET /banking_otc/contracts/active
export const getActiveContracts = (discomId, stateId = 6) => {
  const url = `${BASE_URL}/contracts/active${buildQuery({
    discom_id: discomId,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/contracts/inactive
export const getInactiveContracts = (discomId, stateId = 6) => {
  const url = `${BASE_URL}/contracts/inactive${buildQuery({
    discom_id: discomId,
    state_id: stateId,
  })}`;
  return getApi(url);
};

// GET /banking_otc/traders — { traders: string[], count: number }
export const getTraders = () => {
  const url = `${BASE_URL}/traders`;
  return getApi(url);
};

// GET /banking_otc/contracts/detail?connection_id=...&state_id=...&discom_id=...
export const getContractDetail = (connectionId, stateId = 6, discomId) => {
  const url = `${BASE_URL}/contracts/detail${buildQuery({
    connection_id: connectionId,
    state_id: stateId,
    discom_id: discomId,
  })}`;
  return getApi(url);
};
